// @ts-nocheck
import { useState } from "react";
import "./TabelaReembolso.css";
import { FaDownload, FaEdit } from "react-icons/fa";
import { downloadLastSentByIdSindicato } from "../../../../../services/ExtractService";
import { Modal, Spinner, Button } from "react-bootstrap";
import NotificationToast from "../../../../../components/NotificationToast/NotificationToast";
import {
  downloadComprovanteDespesaSolicitacaoByIdentificador,
  downloadArquivoExtratoSolicitacao,
  uploadComprovanteAssinatura,
} from "../../../../../services/FinanceiroService";

import AssinaturaUpload from "../AssinaturaUpload/AssinaturaUpload";

const TabelaReembolso = ({
  TabelaReembolso = [],
  solicitacoes = [],
  onChange,
  readOnly = false,
  idSindicato,
  extratoSolicitacaoId = null,
  assinaturaFusionId,
  onChangeAssinaturaFusionId,
  onUploadAssinaturaPDF,
  onDownloadAssinaturaPDF,
  onSalvarAssinatura,
  onAssinaturaEnviadaSuccess,
  assinaturaUploading = false,
  assinaturaDownloading = false,
  assinaturaSaving = false,
  assinaturaFileName = "",
  assinaturaHasFile = false,
  onClearAssinaturaFile,
  situacaoEnvioComprovante,
  modoSimples = false,
}) => {
  const parcelas = Array.isArray(TabelaReembolso) ? TabelaReembolso : [];
  const [downloading, setDownloading] = useState(false);
  const [showAssinaturaModal, setShowAssinaturaModal] = useState(false);
  const [rowEditIndex, setRowEditIndex] = useState(null);
  const [fusionIdLocal, setFusionIdLocal] = useState(assinaturaFusionId || "");
  const [fileNameLocal, setFileNameLocal] = useState(assinaturaFileName || "");
  const [hasFileLocal, setHasFileLocal] = useState(!!assinaturaHasFile);
  const [upLocal, setUpLocal] = useState(false);
  const [downLocal, setDownLocal] = useState(false);
  const [saveLocal, setSaveLocal] = useState(false);
  const [fileObjLocal, setFileObjLocal] = useState(null);
  const [solicitacaoAtual, setSolicitacaoAtual] = useState(null);

  const [toast, setToast] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const DISABLED_ALL = true;

  const formatarValor = (valor) =>
    (Number(valor) || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  const valorTotal = parcelas.reduce(
    (total, p) => total + (Number(p?.valor) || 0),
    0,
  );

  const isJaSolicitado = (p) => {
    const s = String(p?.situacao || "")
      .trim()
      .toLowerCase();
    return s === "já solicitado" || s === "solicitando" || s === "solicitado";
  };

  const isMarcada = (p) => !!(p?.solicitar || isJaSolicitado(p) || p?._locked);

  const handleCheckboxChange = () => { };

  const handleDownload = async (e) => {
    e.preventDefault();
    if (downloading) return;

    setDownloading(true);
    try {
      if (extratoSolicitacaoId != null && extratoSolicitacaoId !== "") {
        await downloadArquivoExtratoSolicitacao(
          extratoSolicitacaoId,
          `extrato_${extratoSolicitacaoId}.pdf`,
        );
        return;
      }

      const ret = await downloadLastSentByIdSindicato(idSindicato);
      if (!ret) throw new Error("Extrato não encontrado ou resposta inválida.");

      const { url, filename } = ret;
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || `extrato_${idSindicato}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (err) {
      console.error("Erro ao baixar extrato:", err);
    } finally {
      setDownloading(false);
    }
  };

  const getSolicitacaoByParcela = (parcela) => {
    if (!Array.isArray(solicitacoes) || solicitacoes.length === 0) return null;

    const tipoParcela = Number(
      parcela?.idTipoParcela || parcela?.tipoParcela || 0,
    );
    const solic = solicitacoes.find(
      (s) =>
        Array.isArray(s.idTipoParcela) && s.idTipoParcela.includes(tipoParcela),
    );

    return solic || null;
  };

  const openAssinaturaModal = (idx) => {
    const assinaturaUnificada =
      parcelas.length >= 2 &&
      parcelas.every((p) =>
        ["solicitando", "já solicitado", "solicitado"].includes(
          String(p?.situacao || "")
            .trim()
            .toLowerCase(),
        ),
      );

    let parcela = parcelas[idx];
    if (assinaturaUnificada && !parcela?.idSolicitacao) {
      parcela = parcelas.find((p) => !!p?.idSolicitacao) || parcelas[0];
    }

    const solic = getSolicitacaoByParcela(parcela);

    setSolicitacaoAtual(solic);
    setRowEditIndex(idx);

    if (solic) {
      setFusionIdLocal(solic.codigoFusion || "");
      setFileNameLocal("");
      setHasFileLocal(!!solic.identificador);
    }

    setShowAssinaturaModal(true);
  };

  const closeAssinaturaModal = () => {
    setShowAssinaturaModal(false);
    setRowEditIndex(null);
  };

  const handleUploadLocal = async (file) => {
    setUpLocal(true);
    try {
      setFileObjLocal(file);
      setFileNameLocal(file?.name || "");
      setHasFileLocal(!!file);
    } finally {
      setUpLocal(false);
    }
  };
  const handleDownloadLocal = async () => {
    if (!solicitacaoAtual?.identificador) {
      console.warn("Solicitação sem identificador para download.");
      return;
    }

    setDownLocal(true);
    try {


      await downloadComprovanteDespesaSolicitacaoByIdentificador(
        solicitacaoAtual.identificador,
      );
    } finally {
      setDownLocal(false);
    }
  };

  const handleClearLocal = () => {
    setFileObjLocal(null);
    setFileNameLocal("");
    setHasFileLocal(false);
  };

  const handleSalvarComValidacao = async () => {
    const fusionAtual = String(
      (assinaturaFusionId ?? fusionIdLocal) || "",
    ).trim();
    const arquivoAtual = fileObjLocal;
    const temArquivo = Boolean(
      assinaturaHasFile || hasFileLocal || arquivoAtual,
    );

    if (!temArquivo) {
      setToast({
        show: true,
        type: "error",
        message: "Selecione um arquivo PDF antes de enviar.",
      });
      return;
    }

    if (!fusionAtual) {
      setToast({
        show: true,
        type: "error",
        message: "Informe o Código Fusion antes de enviar.",
      });
      return;
    }

    const assinaturaUnificada =
      parcelas.length >= 2 &&
      parcelas.every((p) =>
        ["solicitando", "já solicitado", "solicitado"].includes(
          String(p?.situacao || "")
            .trim()
            .toLowerCase(),
        ),
      ) &&
      parcelas.every((p) => Number(p?.valor) > 0);

    let parcelaAtual = parcelas[rowEditIndex];
    if (assinaturaUnificada && !parcelaAtual?.idSolicitacao) {
      parcelaAtual = parcelas.find((p) => !!p?.idSolicitacao) || parcelas[0];
    }

    const tipoParcela = Number(parcelaAtual?.idTipoParcela || 0);
    const solicitacaoCorrespondente = solicitacoes.find(
      (s) =>
        Array.isArray(s.idTipoParcela) && s.idTipoParcela.includes(tipoParcela),
    );

    const idSolicitacao =
      parcelaAtual?.idSolicitacao || solicitacaoCorrespondente?.idSolicitacao;


    if (!idSolicitacao) {
      setToast({
        show: true,
        type: "error",
        message: "Solicitação não encontrada para esta parcela.",
      });
      return;
    }

    setSaveLocal(true);
    try {
      const payload = {
        idSindicato,
        idSolicitacao,
        codigoFusion: fusionAtual,
        arquivo: arquivoAtual,
      };

      await uploadComprovanteAssinatura(payload);

      setToast({
        show: true,
        type: "success",
        message: "Comprovante de assinatura enviado com sucesso!",
      });
      closeAssinaturaModal();

      if (typeof onAssinaturaEnviadaSuccess === "function") {
        onAssinaturaEnviadaSuccess();
      } else {
        setTimeout(() => window.location.reload(), 1500);
      }
    } catch (e) {
      console.error("❌ Erro ao salvar assinatura:", e);
      setToast({
        show: true,
        type: "error",
        message: "Para reenviar, anexe um novo PDF.",
      });
    } finally {
      setSaveLocal(false);
    }
  };

  const effectiveFusionId = assinaturaFusionId ?? fusionIdLocal;
  const setEffectiveFusionId =
    onChangeAssinaturaFusionId ?? ((v) => setFusionIdLocal(v));
  const effectiveOnUpload = onUploadAssinaturaPDF ?? handleUploadLocal;
  const effectiveOnDownload = onDownloadAssinaturaPDF ?? handleDownloadLocal;
  const effectiveUploading = assinaturaUploading || upLocal;
  const effectiveDownloading = assinaturaDownloading || downLocal;
  const effectiveSaving = assinaturaSaving || saveLocal;
  const effectiveFileName = assinaturaFileName || fileNameLocal;
  const effectiveHasFile = assinaturaHasFile || hasFileLocal;
  const effectiveOnClear = onClearAssinaturaFile ?? handleClearLocal;

  const norm = (s) =>
    String(s || "")
      .trim()
      .toLowerCase();
  const isStatusSolicitado = (p) => {
    const s = norm(p?.situacao);
    return s === "solicitado" || s === "já solicitado";
  };

  if (modoSimples) {
    return (
      <div className="card shadow-sm p-4 mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold text-uppercase m-0">
            Informações completas para o reembolso
          </h5>

          <button
            className="btn-primario btn-acao d-flex align-items-center gap-2"
            disabled={downloading}
            onClick={handleDownload}
          >
            {downloading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span>Gerando...</span>
              </>
            ) : (
              <>
                <FaDownload size={14} />
                Baixar Extrato
              </>
            )}
          </button>
        </div>

        <div className="table-responsive">
          <table className="table tabela-reembolso mb-0">
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {parcelas.map((parcela, index) => (
                <tr key={index}>
                  <td>{parcela.descricao?.toUpperCase()}</td>
                  <td>{formatarValor(parcela.valor)}</td>
                </tr>
              ))}
              <tr>
                <td className="fw-bold">VALOR TOTAL LÍQUIDO</td>
                <td className="fw-bold">{formatarValor(valorTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm p-4 mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold text-uppercase m-0">
          Informações completas para o reembolso
        </h5>

        <button
          className="btn-primario btn-acao d-flex align-items-center gap-2"
          disabled={downloading}
          onClick={handleDownload}
        >
          {downloading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span>Gerando...</span>
            </>
          ) : (
            <>
              <FaDownload size={14} />
              Baixar Extrato
            </>
          )}
        </button>
      </div>

      <div className="table-responsive">
        <table className="table tabela-reembolso mb-0">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Solicitar</th>
              <th>Situação</th>
              <th className="text-center col-assinatura">Assinatura</th>
            </tr>
          </thead>
          <tbody>
            {parcelas.map((parcela, index) => {
              const checked = isMarcada(parcela);

              const assinaturaUnificada =
                parcelas.length >= 2 &&
                solicitacoes.some(
                  (s) =>
                    Array.isArray(s.idTipoParcela) &&
                    s.idTipoParcela.includes(1) &&
                    s.idTipoParcela.includes(2),
                ) &&
                parcelas.every((p) =>
                  ["solicitando", "já solicitado", "solicitado"].includes(
                    String(p?.situacao || "")
                      .trim()
                      .toLowerCase(),
                  ),
                );

              return (
                <tr
                  key={index}
                  className={`row-disabled ${isStatusSolicitado(parcela) ? "row-solicitado" : ""
                    }`}
                >
                  <td>{parcela.descricao?.toUpperCase()}</td>
                  <td>{formatarValor(parcela.valor)}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={DISABLED_ALL}
                      onChange={handleCheckboxChange}
                      title="Seleção desabilitada"
                    />
                  </td>
                  <td>{parcela.situacao?.toUpperCase()}</td>

                  {assinaturaUnificada ? (
                    index === 0 ? (
                      <td className="text-center" rowSpan={2}>
                        <Button
                          className="btn-edit"
                          size="sm"
                          onClick={() => openAssinaturaModal(0)}
                          title="Editar assinatura"
                          disabled={
                            String(parcelas[1]?.situacao || "")
                              .trim()
                              .toLowerCase() === "a solicitar" ||
                            ![
                              "assinatura pendente",
                              "assinatura concluída",
                            ].includes(
                              String(situacaoEnvioComprovante || "")
                                .trim()
                                .toLowerCase(),
                            )
                          }
                        >
                          <FaEdit />
                        </Button>
                      </td>
                    ) : null
                  ) : (
                    <td className="text-center">
                      <Button
                        className="btn-edit"
                        size="sm"
                        onClick={() => openAssinaturaModal(index)}
                        title="Editar assinatura"
                        disabled={
                          String(parcela.situacao || "")
                            .trim()
                            .toLowerCase() === "a solicitar" ||
                          ![
                            "assinatura pendente",
                            "assinatura concluída",
                          ].includes(
                            String(situacaoEnvioComprovante || "")
                              .trim()
                              .toLowerCase(),
                          )
                        }
                      >
                        <FaEdit />
                      </Button>
                    </td>
                  )}
                </tr>
              );
            })}
            <tr>
              <td className="fw-bold">VALOR TOTAL LÍQUIDO</td>
              <td className="fw-bold">{formatarValor(valorTotal)}</td>
              <td></td>
              <td>-</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <Modal
        centered
        show={showAssinaturaModal}
        onHide={closeAssinaturaModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Assinatura — Parcela {rowEditIndex != null ? rowEditIndex + 1 : ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AssinaturaUpload
            title="ASSINATURA (PDF / FUSION)"
            fusionId={effectiveFusionId}
            identificador={solicitacaoAtual?.identificador}
            AssinaturaUpload={solicitacaoAtual?.AssinaturaUpload}
            nomeArquivo={solicitacaoAtual?.nomeArquivo}
            onChangeFusionId={setEffectiveFusionId}
            onUpload={effectiveOnUpload}
            onDownload={(id) => effectiveOnDownload(id)}
            uploading={effectiveUploading}
            downloading={effectiveDownloading}
            fileName={effectiveFileName}
            hasFile={effectiveHasFile}
            onClearFile={effectiveOnClear}
            showSaveButton={false}
          />
        </Modal.Body>

        <Modal.Footer className="justify-content-end">
          <Button
            className="btn-primario btn-acao"
            onClick={handleSalvarComValidacao}
            disabled={effectiveSaving || effectiveUploading}
            title="Salvar assinatura"
          >
            {effectiveSaving ? "Enviando..." : "Salvar assinatura"}
          </Button>
        </Modal.Footer>
      </Modal>

      {toast.show && (
        <NotificationToast
          show={toast.show}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast((prev) => ({ ...prev, show: false }))}
        />
      )}
    </div>
  );
};

export default TabelaReembolso;
